/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, setLanguage} from '../../../i18n/Metronici18n'
// Import all named exports from _requests
import * as authRequests from "../../../../app/modules/auth/core/_requests";
import {useAuth} from "../../../../app/modules/auth";
import {tenantArabicFlag} from '../../../../app/tenant/tenantState'

// Built at render, not module load: the Arabic flag is the tenant's home country, and the tenant config
// is only loaded by bootstrap after this module has been imported.
const getLanguages = () => [
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'ar',
    name: 'Arabic',
    flag: toAbsoluteUrl(tenantArabicFlag()),
  },
]

const Languages: FC = () => {
  const lang = useLang()
  const languages = getLanguages()
  const {currentUser} = useAuth()
  const currentLanguage = languages.find((x) => x.lang === lang)

  // Effect to handle API call after page reload
  useEffect(() => {
    const pendingLanguageUpdate = localStorage.getItem('pendingLanguageUpdate')
    if (pendingLanguageUpdate) {
      // Clear the pending update first to prevent loops
      localStorage.removeItem('pendingLanguageUpdate')
      // Use the function from the imported namespace
      authRequests.changeLanguage(currentUser?.token || '', pendingLanguageUpdate)
        .catch((error: any) => console.error('Failed to update language on server:', error))
    }
  }, [currentUser])

  const languageHandler = (selectedLang: string) => {
    try {
      // Update local language state
      setLanguage(selectedLang)
      // Store the selected language to be updated after reload
      localStorage.setItem('pendingLanguageUpdate', selectedLang)
      // Reload page to apply language change
      document.location.reload()
    } catch (error) {
      console.error('Failed to change language:', error)
    }
  }

  return (
    <div
      className='menu-item'
      data-kt-menu-trigger='click'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <a 
        href='#' 
        className='menu-link px-5 text-nowrap bg-white' 
        onClick={(e) => {
          e.preventDefault()
        }}
      >
        <span className='menu-title position-relative'>
          <span className='fs-8 rounded px-3 py-2 top-50 end-0 font-0-p'>
            {currentLanguage?.name}{' '}
            <img
              className='w-15px h-15px rounded-1'
              src={currentLanguage?.flag}
              alt='metronic'
            />
          </span>
        </span>
      </a>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
          >
            <a
              href='#'
              onClick={(e) => {
                e.preventDefault()
                languageHandler(l.lang)
              }}
              className={clsx('menu-link d-flex px-5 gap-2', {active: l.lang === currentLanguage?.lang})}
            >
              <span className='symbol symbol-20px'>
                <img className='rounded-1' src={l.flag} alt='metronic' />
              </span>
              {l.name}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
